/**
 * @module LocalStorageKeys
 * @description Project localstorage keys should starts with LS_ prefix
 * @example localStorage.getItem(LS_TOKEN)
 */

export const LS_TOKEN = "token";
export const LS_THEME = "theme";
export const LS_ACADEMIC_YEAR_ID = "academicYearId";
export const LS_USERDATA = "userData";
export const LS_BRANCHID = "branchId";
export const LS_EMPLOYEE_ID = "employeeId";
export const LS_I18NEXT_LANG = "i18nextLng";
export const LS_SCHEDULE_SHOW = "schedule_show";
export const LS_CURRENCY_ID = "currencyId";
export const LS_CURRENCY_NAME = "currencyName";
export const LS_CURRENCY_SYMBOL = "currencySymbol";
export const LS_CURRENCY_CODE = "currencyCode";
export const LS_ORGANIZATION_ID = "organizationId";